/**
 * [退押金退款弹窗]
 * @Author: Fu Xiaochun
 * @Email:  f2e.xiaochun@gmail.com
 */
import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import styles from './RefundModal.module.scss';
import http from '@/assets/api/http';
import { EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';
import { Modal, message, Radio, Input, Table } from 'antd';
import {  regFenToYuan } from '@/util/money';
import { tooltipStyle, tooltip, cellWidth, priceFenToYuanCell } from '@/components/TableCell';

const { TextArea } = Input;

function RefundModal(props){
    console.log(props);

    const [password, setPassword] = useState('');
    const [remark, setRemark] = useState('');
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [refundFee, setRefundFee] = useState(0);

    useEffect(()=>{
        let temp = [];
        let fee = 0;
        if(props.id){
            let item = props.item.recordResps.find(v=>v.id == props.id);
            if(item){
                fee = item.refundFee;
                temp = [item.id];
            }
        }else{
            props.item.recordResps.forEach(v=>{
                if(v.refundStatus === 'TODO'){
                    temp.push(v.id);
                    fee += parseFloat(v.refundFee);
                }
            });
        }
        
        setRefundFee(fee);
        setSelectedRowKeys(temp);
    }, []);

    const digitToChineseMoney = (num) => {
        if (typeof num === 'string' && !/^-?\d+(\.\d{1,2})?$/.test(num) ||
            typeof num === 'number' && isNaN(num)) return '金额格式错误';

        const [intStr, decStr = ''] = String(Number(num).toFixed(2)).split('.');
        const int = intStr.replace('-', '');                 // 去掉负号
        const dec = decStr.padEnd(2, '0').slice(0, 2);       // 保留 2 位小数

        const digit = '零壹贰叁肆伍陆柒捌玖';
        const unit  = ['元','拾','佰','仟','万','拾','佰','仟','亿','拾','佰','仟','万'];
        const decUnit = ['角','分'];

        // 处理整数部分
        let intRes = '';
        for (let i = 0; i < int.length; i++) {
            const n = int[int.length - 1 - i];                 // 从个位开始
            intRes = digit[n] + unit[i] + intRes;
        }
        intRes = intRes
            .replace(/零[拾佰仟]/g, '零')
            .replace(/零{2,}/g, '零')
            .replace(/零(?=万|亿)/g, '')
            .replace(/亿万/g, '亿')
            .replace(/零+元/g, '元');

        // 处理小数部分
        let decRes = '';
        for (let i = 0; i < 2; i++) {
            decRes += digit[dec[i]] + decUnit[i];
        }
        decRes = decRes.replace(/零[角分]/g, '');

        let result = intRes + (decRes || '整');
        result = result.replace(/^元/, '');                  // 去掉开头的“元”
        if (!intRes || intRes === '元') result = result.replace('元', '');

        return intStr === '0' && dec === '00'
            ? '零元整'
            : (num < 0 ? '负' : '') + result;
    };

    const onOk = ()=>{
        if(selectedRowKeys.length == 0){
            message.warn('请勾选要原路退回的支付单！');
            return false;
        }
        if(!password){
            message.warn('请输入财务密码！');
            return false;
        }
        let params = {
            listIds: selectedRowKeys,
            password: password,
            desc: remark
        };

        http('/?cmd=com.xqxc.api.pig.mis.biz.account.RiderDepositMisService.agreeDepositRefund', params, 'POST').then((res) => {
            message.success('操作成功！');
            props.onOk();
        }).catch((e) => {
            message.error(e.message);
        });
    };

    const onCancel = ()=>{
        props.onClose();
    };

    const onPasswordChange = (e)=>{
        let val = e.target.value;
        setPassword(val);
    };

    const onRemarkChange = (e)=>{
        let val = e.target.value || '';
        val = val.trim();
        setRemark(val);
    };

    const maskName = (value)=>{
        const name = value ? value.toString() : '';
        const len = name.length;
        if(len == 0){
            return value;
        }else if (len > 0 && len <= 2) {
            return name.substr(0, 1) + '*';
        } else {
            return name.substr(0, 1) + '*' + name.substr(len - 1);
        }
    };

    const maskTel = (tel)=>{
        return tel.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2');
    };

    const columns = [
        {
            title: '原支付单号',
            dataIndex: 'payId',
        },
        {
            title: '支付方式',
            dataIndex: 'payTypeName',
        },
        {
            title: '支付金额(元)',
            dataIndex: 'payFee',
            render: priceFenToYuanCell
        },
        {
            title: '剩余可退金额(元)',
            dataIndex: 'refundFee',
            render: priceFenToYuanCell
        },
    ];

    const onSelectChange = (newSelectedRowKeys) => {
        console.log('selectedRowKeys changed: ', newSelectedRowKeys);
        let fee = 0;
        if(newSelectedRowKeys.length == 0){
            fee = 0;
        }else{
            props.item.recordResps.forEach(v=>{
                if(v.refundStatus === 'TODO' && newSelectedRowKeys.includes(v.id)){
                    fee += parseFloat(v.refundFee);
                }
            });
        }
        setRefundFee(fee);
        setSelectedRowKeys([...newSelectedRowKeys]);
    };

    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange,
        getCheckboxProps: (record) => ({
            disabled: record.refundStatus !== 'TODO',
        }),
    };

    return <Modal title="退款" open={true} onOk={onOk} width="700px" onCancel={onCancel}>
        <div className={styles.container}>
            <div className={styles.item}>
                <div className={styles.label}>账户信息</div>
                <div className={styles.val}>{props.item.settleAccountId}, {maskName(props.item.riderName || '-')}（{maskTel(props.item.riderTel)}）</div>
            </div>
            <div className={styles.item}>
                <div className={styles.label}>退款金额</div>
                <div className={styles.val}>¥<strong>{regFenToYuan(refundFee)}</strong> ({digitToChineseMoney(regFenToYuan(refundFee))})</div>
            </div>
            {props.id ? null : (
                <div className={styles.tableBox}>
                    <Table rowKey="id" rowSelection={rowSelection} columns={columns} dataSource={props.item.recordResps} pagination={false} scroll={{y: '400px'}} />
                </div>
            )}
            
            <div className={styles.item}>
                <div className={styles.label}><span>*</span>财务密码</div>
                <div className={styles.val}>
                    <Input.Password value={password} onChange={onPasswordChange} placeholder="请输入财务密码" />
                </div>
            </div>
            <div className={styles.item}>
                <div className={styles.label}>付款备注</div>
                <div className={styles.val}>
                    <TextArea rows={4} value={remark} onChange={onRemarkChange} placeholder="请输入付款备注" />
                </div>
            </div>
            <div className={styles.tips}>退款是否成功点击确定后刷新页面查看付款状态</div>
        </div>
      </Modal>;
}

RefundModal.propTypes = {
    id: PropTypes.number,
    item: PropTypes.object,
    onOk: PropTypes.func,
    onClose: PropTypes.func
};

export default RefundModal;